import React from 'react';
import { Button } from '@heroui/react';
import { FiSend } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ShareButtonProps {
  title: string;
  text?: string;
  url: string;
}

export const ShareButton: React.FC<ShareButtonProps> = ({ title, text, url }) => {
  const { t } = useTranslation();

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: text || '',
          url,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    }
  };

  return (
    <Button
      variant="light"
      onPress={handleShare}
      startContent={<FiSend className="text-xl" />}
      size="md"
    >
      {t('actions.share')}
    </Button>
  );
}; 